module.exports = __webpack_public_path__ + "img/nodata_approved.6a990b48.png";